import { getPreviousTab } from "@configure/previousTab";
import statusConfig from "@configure/StatusConfig";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { LoaderComponent } from "../../../auth/PrivateRoute";
import { API_ROUTES, apiGet, apiPost } from "../../../configure/apiConfig";
import { RM_PATH } from "../../../configure/PathConfig";
import { PageWrapper } from "../../../globalStyles";
import { setPath } from "../../../redux/slices/BreadCrumbsSlice";
import OverviewTab from "./servicecomponents/Overview";

export const saveData = async (saveDetails,projectid,header) => {
	try {
		const response = await apiPost(
			API_ROUTES.SAVE_ADDITIONAL_INFO,
			saveDetails,
			null,
			header
			// { "Socket-Action" : actionNameConfig.SCOPED.ADDITIONAL_INFO_UPDATION_IN_SCOPED, "Socket-Deal-Id":projectid },
		);
		return response
	} catch (error) {
    console.error("Error saving data:", error);
    return error
	}
};

const PreliminaryStaffingOverview = () => {
	const { projectid, dealstatus } = useParams();
	const pathname = useLocation().pathname;
	const isRm = pathname.includes(RM_PATH);
	const [isLoading, setIsLoading] = useState(true);
	const [overviewDetails, setOverviewDetails] = useState([]);

	const dispatch = useDispatch();

	const projectName = overviewDetails?.project_name || "Loading...";

  	// const parentPath = getParentPath()

	// const url = parentPath === RM_PATH? PageConfig["RM"].PROJECTHOME+"/"+formatString(siteConfig["rm.resourceallocation.completed"]) :  parentPath;
// console.log('calling')

	const path = [
		{
			label: "Scoped Dashboard",
			url:getPreviousTab('scoped',dealstatus.includes('completed') ? statusConfig.SCOPEDCMLPT :statusConfig.SCOPEDNEW),
		},
		// { label: "Scoped", url:"" },
		{ label: `${projectName}`, url: "" },
	];

	const getData = useCallback(async (isNeedLoader = true) => {
		try {
			if (isNeedLoader) setIsLoading(true);
			const response = await apiGet(API_ROUTES.GET_NEW_DR_DETAILS_FROM_DB, {
				project_id: projectid,
				module:"scoped"
			});

			if (response.status === 200) {
				setOverviewDetails(response?.data[0] || []);
			}

			setIsLoading(false);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	},[projectid]);

	useEffect(() => {
		getData();
	}, [getData]);

	useEffect(() => {
		dispatch(setPath(path));
	}, [overviewDetails?.project_name]);

	return (
		<>
			{isLoading ? (
				<LoaderComponent />
			) : (
				<PageWrapper className="!bg-background  [&_*]:!font-sans">
					<OverviewTab overviewDetails={overviewDetails} isRm={isRm} getData={getData}/>
				</PageWrapper>
			)}
		</>
	);
};

export default PreliminaryStaffingOverview;
